export default {
	// Inhalt des Modals
	model: {
		id: 0,
		name: '',
		area_id: 0,
		price: 0,
		description: '',
		coordinates: '',

		forced: true
	},

	relations: [
		'graves',
		'categories',
		'graveyards'
	],

	graves: [],

	name: 'areas',

	validate () {
		const parts = this.model.name.split(':')

		this.model.area_id = parts[0]
		this.model.area_id = parseInt(this.model.area_id)
		this.model.price = parseFloat(this.model.price)

		this.model.forced = true

		return true
	},

	validateModel () {
		if (this.model.name.trim() === "") {
			return false
		}

		if (this.model.category_id === 0) {
			return false
		}

		if (this.model.graveyard_id === 0) {
			return false
		}

		return true
	},

	copy (aModel) {
		this.model.id = aModel.id
		this.model.name = aModel.grave_id + ': ' + aModel.name
		this.model.area_id = aModel.area_id
		this.model.coordinates = aModel.coordinates
		this.model.price = aModel.price
		this.model.description = aModel.description
		this.model.category_id = aModel.category_id
		this.model.category_name = aModel.category_name
		this.model.category_price = aModel.category_price
		this.model.graveyard_id = aModel.graveyard_id
		this.model.graveyard_name = aModel.graveyard_name

		this.model.forced = true
		this.graves = []
	},

	// Die Spalten für die Tabelle
  cols: [
		{name: 'Name', json: 'name', type: 'text'}
  ],

	clear () {
		this.model.id = 0
		this.model.name = ''
		this.model.area_id = ''
		this.model.coordinates = ''
		this.model.description = ''
		this.model.forced = true

		this.graves = []
	}
}



// WEBPACK FOOTER //
// ./src/models/areas.js